import { render } from "./SelectMultiple.vue?vue&type=template&id=338e37ba&scoped=true"
import script from "./SelectMultiple.vue?vue&type=script&lang=js"
export * from "./SelectMultiple.vue?vue&type=script&lang=js"

import "./SelectMultiple.vue?vue&type=style&index=0&id=338e37ba&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338e37ba"]])

export default __exports__